var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextbook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a56a43",
    height: 46,
    rx: 4,
    width: 58,
    y: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 8h-4.76l-8.21.01-3.03.01a5.965 5.965 0 0 0-4 1.5 5.766 5.766 0 0 0-2 4.36v-.68l-2-3.14-.66-1.04A5.91 5.91 0 0 0 23 8H7a3 3 0 0 0-3 3v42a3 3 0 0 0 3 3h44a3 3 0 0 0 3-3V11a3 3 0 0 0-3-3z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 9.52v42.02c-.08.07-.16.14-.24.22A5.944 5.944 0 0 0 29 56a5.944 5.944 0 0 0-1.76-4.24c-.08-.08-.16-.15-.24-.22V10.06l2 3.14v.68a5.766 5.766 0 0 1 2-4.36z",
    fill: "#d1d4d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 47v6a3 3 0 0 1-3 3H29a6.009 6.009 0 0 1 6-6h16a3 3 0 0 0 3-3z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15H9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2zm-3 5H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm-1.96 5H9a1 1 0 0 1 0-2h4.04a1 1 0 0 1 0 2zm1.31 5H9a1 1 0 0 1 0-2h5.35a1 1 0 0 1 0 2zM20 35H9a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2zm0 5H9a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2zm-6 5H9a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zm9 0h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zm26 0H35a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2zm0-5H35a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2zm0-5H35.65a1 1 0 0 1 0-2H49a1 1 0 0 1 0 2zm0-5h-9.35a1 1 0 0 1 0-2H49a1 1 0 0 1 0 2zm0-5h-8.04a1 1 0 0 1 0-2H49a1 1 0 0 1 0 2zm0-5h-8.58a1 1 0 0 1 0-2H49a1 1 0 0 1 0 2zm0-5h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.14 11.69-2.93 2.93a13.558 13.558 0 0 0-2.83-2.83l2.93-2.93z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.146 11.691-2.828-2.828a1 1 0 0 1 0-1.414l4.562-4.562a3 3 0 1 1 4.242 4.242l-4.562 4.562a1 1 0 0 1-1.414 0z",
    fill: "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 56H7a3 3 0 0 1-3-3v-6a3 3 0 0 0 3 3h16a6.009 6.009 0 0 1 6 6z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 23a14.01 14.01 0 1 1-5.62-11.21 13.558 13.558 0 0 1 2.83 2.83A13.947 13.947 0 0 1 41 23z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 23a9.5 9.5 0 0 1-.21 2A9.982 9.982 0 0 1 31 32.16c-.64.29-1.311.504-2 .64V13.2c.01 0 .03.01.04.01a9.345 9.345 0 0 1 1.96.63A10.074 10.074 0 0 1 35.66 18 9.956 9.956 0 0 1 37 23zm-8-9.8v19.6A10.016 10.016 0 0 1 18.34 28a10 10 0 0 1 0-10A10.014 10.014 0 0 1 29 13.2z",
    fill: "#9fc9d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19a1 1 0 0 1-1 1h-6.54a9.711 9.711 0 0 1 .88-2H24a1 1 0 0 1 1 1zm0 5a1 1 0 0 1-1 1h-6.8c-.133-.658-.2-1.328-.2-2h7a1 1 0 0 1 1 1zm0 5a1 1 0 0 1-1 1h-4.14a10.247 10.247 0 0 1-1.52-2H24a1 1 0 0 1 1 1zm11.54-9H34a1 1 0 0 1 0-2h1.66c.364.633.66 1.304.88 2zm.46 3a9.5 9.5 0 0 1-.21 2H34a1 1 0 0 1 0-2z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13.84v18.32c-.64.29-1.311.504-2 .64-.658.133-1.328.2-2 .2V13c.672 0 1.342.067 2 .2v.68a4.922 4.922 0 0 1 .04-.67 9.345 9.345 0 0 1 1.96.63z",
    fill: "#84b5cb"
  }))));
}

export default SvgTextbook;